import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { change, Field, getFormValues, reduxForm } from 'redux-form/immutable';
import { Map } from 'immutable';

import { initializeSpecificForm, setConvention, setProducts, FORM_STEP1 } from '../Form/actionCreator';

import { renderFieldRadioIcon, renderFieldText, renderFieldRadioList } from '../Form/renderField';
import { v_required } from '../Form/checkField';
import FormButton from '../FormButton';

import { fetchStarted, fetchCompleted } from '../App/actionCreator';
import { updatedFetch } from '../../utils/fetch/actionCreators';
import { baseURL } from '../../utils/fetch/axios';
import { contractTypes } from '../../utils/commonFormsConfig';
import { onSubmitFail } from '../../utils/commonFormsHandlers';

import { getIsFetching } from '../App/selectors';
import { getFetchAuth } from '../../components/HeaderLogin/selectors';
import { getConvention } from '../Form/selectors';
// import { getQueryStringValue } from '../../utils/commonFunctions';

export const getContractTypes = (t) => {
	return [{
		value: contractTypes.consumption,
		label: t('form.step1.tipoContratto.consumption'),
		icon: 'consumption'
	},
	// {
	// 	value: contractTypes.rechargeable,
	// 	label: t('form.step1.tipoContratto.prepaid'),
	// 	icon: 'rechargeable'
	// },
	// {
	// 	value: contractTypes.flat,
	// 	label: t('form.step1.tipoContratto.monthly'),
	// 	icon: 'flat'
	// }
	];
};


class Step1 extends Component {
	state = {
		conventionInfo: false,
		baseProducts: [],
		conventionProducts: [],
		onLoading: false,
	};

	componentDidMount() {
		// Inizializzazione del campo relativo al codice convenzione se presente nell'URL
		// const { getBaseProducts, initializeSpecificForm, location, conventionValidity, conventionId, baseProducts, initialValues, valuesStep1 } = this.props;
		// const conventionId = getQueryStringValue(location.search, 'conventionId') || getQueryStringValue(location.search, 'convenzione');
		// const productCode = getQueryStringValue(location.search, 'prodotto');

		// let mergedValues = new Map();
		// if(!baseProducts || baseProducts.length <= 0) {
			// getBaseProducts().then((bp) => {
			// 	if(conventionId && !conventionId) {
			// 		this.manageConventionCode(conventionId);
			// 		mergedValues = initialValues.mergeDeep(valuesStep1, { codicePromozionale: conventionId });
			// 		initializeSpecificForm(FORM_STEP1, mergedValues);
			// 	} else if(productCode && !valuesStep1.get('productCode')) {
			// 		const currBp = bp.find(p => p.codice === productCode) || bp.find(p => p.flagDefault === true);
			// 		if(currBp) {
			// 			mergedValues = initialValues.mergeDeep(valuesStep1, { productCode: (currBp.id).toString() });
			// 			initializeSpecificForm(FORM_STEP1, mergedValues);
			// 		}
			// 	}
			// 	if(!productCode && !conventionValidity) {
			// 		const defaultProduct = bp.find(p => p.flagDefault === true);
			// 		const partialState = { productCode: (conventionValidity && conventionId) || (defaultProduct.id).toString() };
			// 		if(conventionId) {
			// 			partialState['codicePromozionale'] = conventionId;
			// 		}
			// 		mergedValues = initialValues.mergeDeep(valuesStep1, partialState);
			// 		initializeSpecificForm(FORM_STEP1, mergedValues);
			// 	}
			// });
		// }
		const { initialValues, valuesStep1, convention } = this.props;

		const mergedValues = (initialValues || new Map()).mergeDeep(valuesStep1 || new Map());
		const plainMergedValues = mergedValues.toJS();

		if(plainMergedValues.tipoContratto) {
			if(convention.validity) {
				this.registerConventionCode(plainMergedValues.tipoContratto);
			} else {
				this.getProducts(plainMergedValues.tipoContratto);
			}
		}
	}

	formatProducts = (products) => {
		return products.map((p) => {
			return {
				value: (p.product_code).toString(),
				text: p.product_name,
				description: p.product_description
			};
		});
	};

	getProducts = (family) => {
		const { setProducts, updatedFetch, fetchAuth, change } = this.props;

		this.setState({ onLoading: true });

		updatedFetch('GET', baseURL + '/UserData/products', { productType: 'SdR', salesChannel: 'Web', family }, [], [(response) =>  setProducts(response.list)], [], fetchAuth).then((products) => {
			const baseProducts = this.formatProducts(products.list);
			this.setState({ baseProducts, onLoading: false }, () => {
				if(baseProducts.length > 0) {
					change('productCode', baseProducts[0].value);
				} else {
					change('productCode', '');
				}
			});
		});
	};

	openInfo = (e, info) => {
		e.preventDefault();
		this.setState((prevState) => {
			return { [info]: !prevState[info] };
		});
	};

	registerConventionCode = (family = false) => {
		const { valuesStep1, updatedFetch, fetchAuth, setConvention, change, setProducts } = this.props;
		const values = valuesStep1 ? valuesStep1.toJS() : {};

		updatedFetch('GET', baseURL + '/UserData/products', { productType: 'SdR', salesChannel: 'Web', family: family || values.tipoContratto, promoCode: values.codicePromozionale }, [fetchStarted], [fetchCompleted], [], fetchAuth).then((products) => {
			if(products.list.length > 0) {
				const conventionProducts = this.formatProducts(products.list);
				this.setState({ conventionProducts }, () => {
					setConvention(values.codicePromozionale, true);
					change('productCode', conventionProducts[0].value);
				});
				setProducts(products.list);
			} else {
				setConvention(values.codicePromozionale, false);
				this.getProducts(family || values.tipoContratto);
			}
		});
	};

	render() {
		const { handleSubmit, valuesStep1, isFetching, t, cardType, convention, setConvention, change } = this.props;
		const { baseProducts, conventionProducts, conventionInfo, onLoading } = this.state;

		const values = valuesStep1 ? valuesStep1.toJS() : {};
		let contractOptions = Array.from(getContractTypes(t));
		if(cardType === 3) {
			contractOptions = contractOptions.filter(o => o.value !== contractTypes.consumption);
		}

		return <div>
			<form onSubmit={handleSubmit} noValidate>
				<div className='row'>
					<div className='form-group col-md-10 col-lg-8 col-xl-10 col-center position-relative'>
						{
							<Fragment>
								<label>{t('form.step1.tipoContratto.label')}</label>
								<Field name='tipoContratto' options={contractOptions} component={renderFieldRadioIcon} validate={[(value) => v_required(value, t)]} inverted change={(checked, family) => {
									this.setState({ conventionInfo: false }, () => {
										setConvention('', false);
										change('codicePromozionale', '');
										this.getProducts(family);
									});
								}} />
							</Fragment>
						}
					</div>
				</div>

				<div className='row'>
						<div className='form-group col-md-10 col-lg-8 col-xl-10 col-center'>
							<label>{t('form.step1.productCode')}</label>
							{values.tipoContratto && !onLoading ?
								<Field name='productCode' options={convention.validity ? conventionProducts : baseProducts} component={renderFieldRadioList} validate={[(value) => v_required(value, t)]} inverted />
								: <div className="bg-light mt-3 mx-5 rounded-3" style={{ height: '100px'}}></div>
							}
						</div>
					</div>

				<div className='form-row search-code'>
					<div className='form-group col-lg-12 col-xl-11 offset-xl-1'>
						<button className='btn btn-lg btn-link no-padding shadow-none' onClick={(e) => this.openInfo(e, 'conventionInfo')}>{t('form.step1.codicePromozionaleOpen')}</button>

						{(convention.validity || conventionInfo) &&
							<div className='row'>
								<div className='col-sm-4 col-md-4 col-lg-4 col-xl-4'>
									<Field name='codicePromozionale' label={t('form.step1.codicePromozionale')} labelClass='label-sm' inputClass='form-control-sm' component={renderFieldText} />
								</div>
								<div className='col-sm-4 col-md-4 col-lg-4 col-xl-4'>
									<button type='button' className='btn btn-sm btn-primary inline' disabled={!values.codicePromozionale || values.codicePromozionale.length === 0 || isFetching} onClick={() => this.registerConventionCode()}>{t('form.step1.codicePromozionaleConfirm')}</button>
								</div>
							</div>
						}

						{
							convention.name && convention.validity ? <label className='label-sm mt-2'>{t('form.step1.codicePromozionaleSelected')} {convention.name}</label> : ''
						}

						{
							convention.name && !convention.validity ? <label className='label-sm mt-2'>{t('form.step1.codicePromozionaleError')}</label> : ''
						}

					</div>
				</div>

				<FormButton {...this.props} stopNext={!baseProducts.length || onLoading}></FormButton>

			</form>
		</div>;
	}
}

const mapStateToProps = (state, props) => {
	return {
		initialValues: {
			tipoContratto: props.cardType === 3 ? contractTypes.rechargeable : contractTypes.consumption
		},
		valuesStep1: getFormValues(FORM_STEP1)(state),
		fetchAuth: getFetchAuth(state),
		isFetching: getIsFetching(state),
		convention: getConvention(state).toJS()
	};
};

const mapDispatchToProps = {
	updatedFetch,
	initializeSpecificForm,
	change,
	setConvention,
	setProducts
};

Step1.propTypes = {
	initialValues: PropTypes.object,
	valuesStep1: PropTypes.object,
	initializeSpecificForm: PropTypes.func,
	change: PropTypes.func,
	handleSubmit: PropTypes.func,

	updatedFetch: PropTypes.func,
	fetchAuth: PropTypes.object,
	isFetching: PropTypes.bool,
	// location: PropTypes.object,
	cardType: PropTypes.number,
	convention: PropTypes.object,
	setConvention: PropTypes.func,
	setProducts: PropTypes.func,
	t: PropTypes.func
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: FORM_STEP1, // a unique name for this form
	destroyOnUnmount: false,
	onSubmitFail: (errors) => {
		onSubmitFail(errors);
	}
	// keepDirtyOnReinitialize: true,
	// enableReinitialize: true
	// validate,   // <--- validation function given to redux-form
  // warn        // <--- warning function given to redux-form
})(Step1)));
